export const configurationTypes = {
  voicePhoneNumberCarrier: 'VoicePhoneNumberCarrier',
  voicePhoneNumberPorted: 'VoicePhoneNumberPorted',
  voiceTollFreePortedCarrier: 'VoiceTollFreePortedCarrier',
  voiceTollFreePortedNumber: 'VoiceTollFreePortedNumber',
};
